import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type ReportUiState = {
  pageSize: number;
};

const initialState: ReportUiState = {
  pageSize: 10,
};

const pageSizeSlice = createSlice({
  name: "pageSize",
  initialState,
  reducers: {
    setPageSize(state, action: PayloadAction<number>) {
      state.pageSize = action.payload;
    },
  },
});

export const { setPageSize } = pageSizeSlice.actions;
export default pageSizeSlice.reducer;
